<div class="detail-card">
  <div class="d-flex align-items-center gap-4">
    <div class="d-flex align-items-center gap-2 flex-grow-1">
      <div i18n class="detail-label">Annual Minimum</div>
      <button
        [ngbTooltip]="tooltip"
        aria-label="Annual Minimum information"
        i18n-aria-label
        type="button"
        class="no-style-button">
        <img
          [ngbTooltip]="tooltip"
          src="/assets/icons/grey/CircleQuestion.svg"
          alt=""
          [style.height.rem]="1.5"
          [style.width.rem]="1.5" />
      </button>
    </div>
    <div i18n class="detail-value">{{ (annualMinimum | currency) ?? '-' }}</div>
  </div>
</div>

<ng-template #tooltip>
  <div *ngIf="isEstimated; else actualTooltip" class="tooltip-text" i18n>
    The minimum total payment amount required for the year, based on estimates from the previous year for the variable
    benefit account balance(s) and the selected minimum age(s)
  </div>
</ng-template>

<ng-template #actualTooltip>
  <div class="tooltip-text" i18n>
    The minimum total payment amount required for the year, based on the variable benefit account balance(s) at the
    start of the year and the selected minimum age(s)
  </div>
</ng-template>
